import { FC, ReactElement } from 'react'
import { Redirect } from 'react-router'
import FullBlock from './components/fullBlock'
import { useAuth } from './hooks/auth'
import { RoutesEnum } from './utils/routesEnum'

const AuthGuard: FC = ({ children }): ReactElement => {
  const { status, accessToken } = useAuth()

  if (status === 'pending' || !accessToken) {
    return <FullBlock>Aguarde...</FullBlock>
  }

  if (status === 'not-logged') {
    return (
      <>
        <Redirect to={RoutesEnum.LOGIN} />
        <FullBlock>Redirecionando...</FullBlock>
      </>
    )
  }

  return (
    <>
      {children}
    </>
  )
}

export default AuthGuard
